"use client";

export function Stepper({
  value,
  onChange,
  min,
  max,
  unitSingular,
  unitPlural,
  decreaseLabel,
  increaseLabel,
}: {
  value: number;
  onChange: (n: number) => void;
  min: number;
  max: number;
  unitSingular: string;
  unitPlural: string;
  decreaseLabel: string;
  increaseLabel: string;
}) {
  function bump(delta: number) {
    onChange(Math.max(min, Math.min(max, value + delta)));
  }

  return (
    <div className="inline-flex h-11 items-center gap-2 rounded-full border border-border bg-surface-muted pl-4 pr-1.5 shadow-[var(--shadow-sm)]">
      <div className="flex-1 text-base font-semibold tabular-nums text-text" aria-live="polite">
        {value}
        <span className="ml-1.5 font-medium text-text-muted">
          {value === 1 ? unitSingular : unitPlural}
        </span>
      </div>
      <button
        type="button"
        aria-label={decreaseLabel}
        disabled={value <= min}
        onClick={() => bump(-1)}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-border bg-surface text-base font-semibold text-text disabled:cursor-not-allowed disabled:opacity-35 focus-ring-tight"
      >
        −
      </button>
      <button
        type="button"
        aria-label={increaseLabel}
        disabled={value >= max}
        onClick={() => bump(1)}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-border bg-surface text-base font-semibold text-text disabled:cursor-not-allowed disabled:opacity-35 focus-ring-tight"
      >
        +
      </button>
    </div>
  );
}
